module.exports = __webpack_public_path__ + "static/media/qrcode-scanner-bg.0ca4686b.png";